<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Status Name"
                invalid-feedback="Status name should be filled"
                required
                v-model="$v.orderStatusForm.name.$model"
                :is-valid="!$v.orderStatusForm.name.$invalid"
              />
            </CCol>

            <CCol sm="3">
              <CInput
                label="Ordering"
                invalid-feedback="Ordering should be filled"
                required
                v-model="$v.orderStatusForm.ordering.$model"
                :is-valid="!$v.orderStatusForm.ordering.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <CTextarea
                label="Deskripsi"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.orderStatusForm.description.$model"
                :is-valid="!$v.orderStatusForm.description.$invalid"
                rows="4"
              />
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.orderStatusForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

export default {
  name: "OrderStatus",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Order Status",
      fields: [
        { key: "name", label: "Nama Status", sorter: true },
        { key: "description", label: "Deskripsi", sorter: true },
        { key: "ordering", label: "Ordering", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      orderStatusForm: tableInterfaces.order_status,
      isLoading: false,
      addButton: false,
      isEdit: false,
    };
  },
  validations: {
    orderStatusForm: {
      name: { required },
      description: { required },
      ordering: {required}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getOrderStatus();
    },
    getOrderStatus: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/order_status/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.orderStatusForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.order_status) {
        tableInterfaces.order_status[i] = null;
      }
      this.orderStatusForm = tableInterfaces.order_status;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/order_status/edit", this.orderStatusForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Order Status",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Order Status",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: "Order Status",
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/order_status/add", this.orderStatusForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
